import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { BaseRequestOptionsArgs, HttpResponse, HttpService } from '@dm/core';
import { ToolService } from 'app/common/services/tool.service';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Eula } from './eula';
import { IsNeedSignE, IsSupportEulaE } from './eula.enum';

@Injectable({
    providedIn: 'root',
})
export class EulaService {
    /**是否需要签署EULA协议 */
    private isSignEulaNeeded = false;
    /**是否已经签署EULA协议 */
    isSignedEula = false;
    /**是否白牌 */
    private isOem = this.toolService.isOem();

    constructor(
        private httpService: HttpService,
        private toolService: ToolService,
    ) { }

    /**
     * 查询EULA信息
     */
    getEulaInfo(options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('eula.get');
        return this.httpService.get(rest, options);
    }

    /**
     * 签署EULA
     * @params 下发参数
     */
    signEula(params: Eula, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('eula.put');
        return this.httpService.put(rest, params, options);
    }

    /**查询是否签署EULA协议，白牌不支持 */
    checkEulaInfo(): Observable<{ data: Eula }> {
        if (this.isOem) {
            return of(null);
        }

        return this.getEulaInfo({ doException: false })
            .pipe(
                tap(({ data }: { data: Eula }) => {
                    // 支持EULA并且不需要签署EULA代表已签署
                    this.isSignedEula = (data.isSupportEula === IsSupportEulaE.YES) && (data.isNeedSign === IsNeedSignE.NOT);
                    // 支持EULA并且需要签署EULA代表需要签署
                    this.isSignEulaNeeded = (data.isSupportEula === IsSupportEulaE.YES) && (data.isNeedSign === IsNeedSignE.YES);
                }),
                catchError((err) => {
                    // 查询失败不用签署，没有查询失败提示，不展示EULA相关内容
                    this.isSignEulaNeeded = false;
                    this.isSignedEula = false;
                    return of(err);
                }));
    }

    /**获取是否需要签署EULA协议 */
    getIsSignEulaNeeded(): boolean {
        return this.isSignEulaNeeded;
    }

    /**获取是否已经签署EULA协议 */
    getIsSignedEula(): boolean {
        return this.isSignedEula;
    }

    /** 设置是否已经签署EULA协议 */
    setIsSignedEula(isSignedEula: boolean): void {
        this.isSignedEula = isSignedEula;
    }

    /**登录页EULA必选校验器 */
    unSignEulaValidate(control: AbstractControl): ValidationErrors {
        return control.value ? null : { unSignEula: true };
    }
}
